module.exports = "/_next/static/images/BlockDataCollection-57aa940534cc6700c30f74fc6f61c0f4.webp";